import en from "./locales/en";
import fr from "./locales/fr";

export const locales = { en, fr } as const;

export type Locale = keyof typeof locales;
export type Dictionary = typeof en;

export const DEFAULT_LOCALE: Locale = "fr";

export { en, fr };
